import { AnalyticPeriodsEnum } from '@workalizer/shared';
import { groupByPeriod } from '@workalizer/shared/utils';
import { formatISO, setMinutes, setSeconds } from 'date-fns';
export var analyticAlertsSummary = function (alerts, dateFrom, dateTo, groupBy) {
    var mappedData = groupBy === AnalyticPeriodsEnum.HOUR
        ? alerts.map(function (alert) { return ({
            items: [alerts],
            date: formatISO(setSeconds(setMinutes(new Date(alert.createdAt), 0), 0))
        }); })
        : alerts.map(function (alert) { return ({
            items: [alerts],
            date: formatISO(alert.createdAt, { representation: 'date' })
        }); });
    var alertsGroupedByPeriod = groupByPeriod(mappedData, new Date(dateFrom), new Date(dateTo), groupBy);
    return alertsGroupedByPeriod.map(function (item) { return ({
        date: item.date,
        count: item.items.length
    }); });
};
